<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '30vw', position: 'relative' }"
      :header="'Alterar Prioridade do Ticket'"
      :modal="true"
      :closable="false"
    >
      <form
        name="HelpdeskTicketsChangePriority"
        class="p-col-12"
        @submit.prevent="setPriority"
        style="min-height: 15vh"
      >
        <Loading
          :active.sync="showLoader"
          :isFullPage="false"
          :zIndex="9000"
        ></Loading>
        <p v-if="!selected">
          <b>Ticket {{ ticketId }} | {{ ticketSubject }}</b>
        </p>
        <p v-else v-for="ticketSelected in selected" :key="ticketSelected.id">
          <b>Ticket {{ ticketSelected.id }} | {{ ticketSelected.subject }}</b>
        </p>
        <div class="p-fluid p-formgrid p-grid" style="min-height: 50vh">
          <div class="p-field p-col-12 p-md-12 p-mt-4">
            <span class="p-float-label">
              <Dropdown
                name="ticketPriority"
                :options="priorityList"
                :filter="true"
                :optionLabel="'name'"
                :optionValue="'priority'"
                v-model="current"
                v-validate="'required'"
                v-bind:class="[
                  { 'p-invalid': errors.has('ticketPriority') },
                  'form-control',
                ]"
              >
              </Dropdown>
              <label for="ticketPriority"
                >Selecionar Prioridade do Ticket</label
              >
            </span>
            <small
              v-if="errors.has('ticketPriority')"
              class="p-error"
              role="alert"
            >
              Prioridade é obrigatório
            </small>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-check"
          class="p-button-success"
          @click="setPriority"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import ticketService from "../../services/tickets.service";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "ChangePriority",
  components: {
    Loading,
  },
  props: [
    "showToast",
    "show",
    "priorityId",
    "ticketId",
    "ticketSubject",
    "selected",
  ],
  watch: {
    priorityId() {
      this.showLoader = false;
      this.$validator.pause();
      this.$validator.reset();
      this.current = !this.selected ? this.priorityId : null;
    },
  },
  data() {
    return {
      current: !this.selected ? this.priorityId : null,
      priorityList: [],
      showLoader: false,
    };
  },
  created() {
    this.getPriorityList();
  },
  methods: {
    getPriorityList() {
      return ticketService
        .getPriorityList()
        .then((response) => (this.priorityList = response));
    },
    cancel() {
      return this.$emit("cancel");
    },
    setPriority() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.$validator.pause();
        this.$validator.reset();
        if (this.selected != null) {
          return this.setPriorityMultipleTickets();
        }
        this.showLoader = true;
        return ticketService
          .setPriority(this.ticketId, { priority_id: parseInt(this.current) })
          .then((response) => {
            this.showLoader = false;
            if (!response) {
              if (this.showToast) {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro ao alterar a prioridade ticket",
                  detail: "",
                  life: 3000,
                });
              }
              return this.$emit("changedTicketPriority", {
                status: "error",
              });
            }

            if (this.showToast) {
              this.$toast.add({
                severity: "success",
                summary: `Prioridade do ticket alterada com sucesso`,
                detail: ``,
                life: 3000,
              });
            }
            return this.$emit("changedTicketPriority", {
              status: "ok",
              result: response,
            });
          });
      });
    },
    async setPriorityMultipleTickets() {
      let noErrors = true;
      let res = null;
      this.showLoader = true;
      for (const ticket of this.selected) {
        await ticketService
          .setPriority(ticket.id, { priority_id: parseInt(this.current) })
          .then((response) => {
            if (!response) {
              return (noErrors = false);
            }
            res = response;
          });
      }
      this.showLoader = false;
      if (!noErrors) {
        if (this.showToast) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao alterar a prioridade ticket",
            detail: "",
            life: 3000,
          });
        }
        return this.$emit("changedTicketPriority", {
          status: "error",
        });
      }
      if (this.showToast) {
        this.$toast.add({
          severity: "success",
          summary: `Prioridade do ticket alterada com sucesso`,
          detail: ``,
          life: 3000,
        });
      }
      return this.$emit("changedTicketPriority", {
        status: "ok",
        result: res,
      });
    },
  },
};
</script>
